import { PROD } from 'const';

if (PROD) {
  (function addGTM (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${ l }` : '';

    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${ i }${ dl }`;
    f.parentNode.insertBefore(j, f);
  }(window, document, 'script', 'dataLayer', 'GTM-P29DBQ6'));
}

function push (...args) {
  if (PROD) {
    window.dataLayer.push(...args);
  } else {
    const { event, ...d } = args[0];
    console.log('[DEV] GTM.push()', d);
  }
}

export function onSuccessSendGtm (reqMethod, gtmMethod, gtmPayload) {
  return (...args) => {
    return reqMethod(...args).then((resp) => {
      gtmMethod(gtmPayload);
      return resp;
    });
  };
}

const GTM = {
  onContactFirstInput: () => push({
    'event': 'addEvents',
    'eventCategory': 'engagement',
    'eventAction': 'form_input',
    'eventLabel': '(empty)',
  }),

  onContactFormSubmit: () => push({
    'event': 'addEvents',
    'eventCategory': 'engagement',
    'eventAction': 'generate_lead',
    'eventLabel': 'Contact Us',
  }),

  consentUpdated: () => push({
    'event': 'addEvents',
    'eventCategory': 'consent',
    'eventAction': 'updated',
    'eventLabel': '(not set)',
  }),
};

export const PrivacySets = {
  get () {
    try {
      return JSON.parse(document.cookie.match(/CookieAccepted=(.+?)(;|$)/)?.[1] || undefined);
    } catch (e) {
      return undefined;
    }
  },

  set (sets) {
    document.cookie = `CookieAccepted=${ JSON.stringify(sets) };path=/;max-age=2147483647`;
  },
};


export default Object.freeze(GTM);

let tracker;
const GA = {
  setPage (page) {
    if (PROD) {
      if (window.ga) {
        if (!tracker) {
          const trackers = window.ga.getAll() || [];
          tracker = trackers[trackers.length - 1]?.get('name');
        }

        window.ga(`${ tracker }.set`, 'page', page);
        window.ga(`${ tracker }.send`, 'pageview');
      }
    }
    else
      console.log('[DEV] GTM.setPage()', page);
  },
};

export { GA };
